import { ENVIRONMENT_CONFIG } from 'Components/MicrosoftAuth/environmentOptions'

export const ApiUrls = {
  EUROPASTRY: ENVIRONMENT_CONFIG.API,
}
